// Playlist module
var $ = require('jquery');

var spotify = require('./../SpotifyService');
var service = require('./../QuizService');

module.exports = {
    template: require('./template.html'),
    replace: false,
    data: function () {
        return {
            themes: [
                {
                    'theme': 'Songs that fit in a Christmas playlist but are not really Christmas songs.'
                },
                {
                    'theme': 'Music that showcases the vocal ability of Michael Jackson.'
                },
                {
                    'theme': 'A tribute to the greatest female vocalists of all time.'
                },
                {
                    'theme': 'Music that could be the soundtrack to the TV series Mad Men.'
                },
                {
                    'theme': 'It takes a real man to cry! Tearjerking, sentimental songs by masculine singers.'
                },
                {
                    'theme': 'Husky voices for those dark autumn days.'
                },
                {
                    'theme': 'Artists that will break through in the next year.'
                },
                {
                    'theme': "Beautifully Sad Pop: Pop so beautiful you can't help to sing and cry along."
                },
                {
                    'theme': 'Sleepy Me: Low energy tunes for a Sunday in bed.'
                },
                {
                    'theme': "Feeling Fabulous: Songs for feeling as if you're on top of the world"
                },
                {
                    'theme': "Sippin' Coffee: Tunes that make your coffee taste perfect."
                },
                {
                    'theme': 'Soulful Morning Glory: Songs that make sure you wake up on the right side of the bed.'
                },
                {
                    'theme': 'Flavorful Cooking: The perfect inspirational music while cooking.'
                },
                {
                    'theme': 'Dog Walkers: Cheerful tunes for walking the dog.'
                },
                {
                    'theme': 'Music to play when your parents-in-law come over for Italian food.'
                },
                {
                    'theme': 'Better than the original - the covers or remixes that you think top the original.'
                },
                {
                    'theme': 'Your favorite songs that have less than 100,000 plays on Spotify.'
                },
                {
                    'theme': 'The most exciting new artists that you think could be superstars in two years.'
                },
                {
                    'theme': "The Italian Mob Boss' Drive-to-work playlist."
                },
                {
                    'theme': 'Electronic Concentration - deep, instrumental music to focus to'
                },
                {
                    'theme': 'Tracks released in 2015 that you believe will stand the test of time and become classics.'
                },
                {
                    'theme': 'The not so obvious California road trip playlist.'
                },
                {
                    'theme': 'THE All-Nighter: From chilled cocktail mingling to the nightclub to falling asleep at the after party.'
                },
                {
                    'theme': 'Bedroom Soul - music to enjoy between the sheets.'
                },
                {
                    'theme': 'Sad, slow Jazz For Sleeping.'
                },
                {
                    'theme': 'Your favorite songs in at least five languages other than English.'
                },
                {
                    'theme': 'If the 1984 TV-series Miami Vice came out in 2015, this is what the soundtrack should sound like.'
                },
                {
                    'theme': 'Cheaters - The infidelity playlist.'
                },
                {
                    'theme': "Songs for when you've completely given up."
                },
                {
                    'theme': 'Spring:  The soundtrack of spring blossom, birds chirping and winter washing away.'
                },
                {
                    'theme': 'When in LA:  Songs about or with a connection to the City of Angels.'
                },
                {
                    'theme': 'Essential Hip-Hop made in New York City.'
                },
                {
                    'theme': 'Plata o Plomo:  A Latin inspired drug cartel movie soundtrack.'
                },
                {
                    'theme': 'Pretend you are creating the soundtrack to a sequel to the 2011 Movie, "Drive".'
                },
                {
                    'theme': 'R&B about bae and me.'
                },
                {
                    'theme': 'Electrohop Workout:  A mix of electronic and Hip-Hop music in roughly the same tempo.'
                },
                {
                    'theme': 'Airplane Vocal Chill:  Music with mellow vocals to help you chill on a long transatlantic flight.'
                },
                {
                    'theme': 'A leading European fashion designer brand asks you to create the playlist for their runway show'
                }
            ],
            search: '',
            answerTracks: [],
            searchTracks: [],
            showStartScreen: false,
            continueApplication: false,
            showplaylisttracks: false,
            yourTheme: null,
            tracksAnswerd: 0
        }
    },
    methods: {

        playlistStart: function () {
            this.showStartScreen = true;
        },

        doSearch: function () {

            if(!$('.formtext').val()) {
                this.showplaylisttracks = false;
            }

            if (this.search.length > 2) {
                var query = this.search;
                this.showplaylisttracks = true;

                var self = this;
                spotify.findTracks(query).then(function (response) {
                    self.searchTracks = response.tracks.items;
                });
            } else {
                this.searchTracks = [];
                this.showplaylisttracks = false;
            }
        },

        thejobclick: function () {

            ga('send', 'event', 'About', 'click', 'About');

            $('.socialQuiz').toggleClass('active');
            $('.btn').toggleClass('active');
            $('.formwrap').toggleClass('active');
            $('.animateQuiz').toggleClass('active');
            $('.closeopen').toggleClass('active');
            $('.aboutWrapper').toggleClass('active');
            $('.overlay').toggleClass('active');
            $('.startText').toggleClass('active');
            $('.quiztext').toggleClass('active');
            $('.aboutskew').toggleClass('active');
            $('.badgewrapper').toggleClass('active');
            $('.wave').toggleClass('active');
            $('.socialStart').toggleClass('active');
            $('.form').toggleClass('active');
            $('.aboutInnerWrap').toggleClass('active');

        },

        selectTrack: function (searchTrack) {

            this.tracksAnswerd++;

            $('.navbarline').css('width', '+=4px');

            this.showplaylisttracks = false;

            $('.formtext').val('');

            if(this.answerTracks.length == 9) {
                console.log(this.answerTracks.length + '   if');
                this.continueApplication = true;
                this.searchTracks = [];
                this.answerTracks.push(searchTrack);

                setTimeout(function() {
                    $('#continueBtnPlaylistAnimate').animate({right:'6%'},500);
                },100);

            } else if(this.answerTracks.length == 10) {
                this.searchTracks = [];
            }
            else {
                console.log(this.answerTracks.length + '  else');
                this.answerTracks.push(searchTrack);
                this.searchTracks = [];
                this.continueApplication = false;
            }
        },

        removeTrack: function (answerTrack) {

             this.tracksAnswerd--;

            $('.navbarline').css('width', '-=4px');

            var index = this.answerTracks.indexOf(answerTrack);
            this.answerTracks.splice(index, 1);
            this.continueApplication = false;
        },

        shuffle: function(array) {

            var currentIndex = array.length, temporaryValue, randomIndex ;

            while (0 !== currentIndex) {

                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }

            return array;
        },

        sendResult: function (theme) {

            var self = this;

            var resultArray = new Array();

            for (var i = 0; i < self.answerTracks.length; i++) {
                resultArray.push({ 'id' : self.answerTracks[i].id,  'name' : self.answerTracks[i].name});
            };


            service.sendPlaylistData(theme, resultArray);


          //  service.sendInterviewData(theme, );




        },

    },
    ready: function () {

        $('.navbarline').css('width', '150px');

        var shuffledThemes = this.shuffle(this.themes);
        this.yourTheme = shuffledThemes[0].theme;

    },
}
